<template>
  <div class="wrap" v-if="serial_number">
    <div class="f-pr">
      <div class="swithLan" @click="swithBoxShow = !swithBoxShow">
        <img
          src="data:image/png;base64,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"
          alt="" class="f-fl">
        <span>{{ lang }}</span>
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjI5Q0Y0NTcwN0I5QTExRTlBOTYzREU0Q0M4MDQ3QzExIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjI5Q0Y0NTcxN0I5QTExRTlBOTYzREU0Q0M4MDQ3QzExIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjlDRjQ1NkU3QjlBMTFFOUE5NjNERTRDQzgwNDdDMTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjlDRjQ1NkY3QjlBMTFFOUE5NjNERTRDQzgwNDdDMTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5LGwbeAAAAlklEQVR42mL4////5P+Ug8kMQIIViPdSYAhILwvIIBAWBeK7ZBhyB6qXAWYQCOsC8WcSDPkM1cOAbhAIBwLxPyIMAakJQNaLbhAI1xNhUB26PmwGMQLxGjyGrIaqIWgQCHMB8SUshlyEyjEQaxAIKwDxKyRDQGx5XOrxGQTCDkD8E4rt8akF+5UAyATif0A8E58igAADAIPugKulYwR9AAAAAElFTkSuQmCC"
          alt="" class="ml5" style="width: 9px; height: 5px;margin-left: 5px;margin-left: 5px;">
      </div>
      <div class="swithBox" v-if="swithBoxShow">
        <div @click="handleSwithBox('CN')" :class="{ on: lang == 'CN' }">CN(简体中文)</div>
        <div @click="handleSwithBox('EN')" :class="{ on: lang == 'EN' }">EN(English)</div>
      </div>
      <img src="@/assets/img/ch-Top.f57c2df6.png" alt="" v-if="lang == 'CN'" />
      <img src="@/assets/img/top.c482e361.png" alt="" v-else />
    </div>
    <template v-if="!isResult">
      <template v-if="lang == 'CN'">
        <div class="CN">
          <div class="centent">
            <p>请刮开涂层</p>

            <div class="securityImg">
              <img src="@/assets/img/securityImg.3e5932e0.png" alt="">
            </div>
            <div class="f-mt28 f-fs18" style="text-align: left;margin-top: 25px;">产品序列号：{{ serial_number }}</div>
            <div>
              <input maxlength="20" type="text" placeholder="请输入涂层下字符" class="securityInput" v-model="code">
            </div>
            <div><button class="securityBtn" @click="handleVerify">验证</button></div>
            <div class="notice fsi">* 部分没有印刷防伪码产品暂不支持查询</div>
            <div class="notice f-mt10 fsi" style="margin-top: 6px;">*
              Swisse防伪查询唯一合法域名为swisse.com，正品经扫码可直接从本页网址看到或点击微信扫码后界面右上角[...]看到swisse.com域名，请注意甄别，谨防受骗。
            </div>
            <div class="f-mt28 f-tc f-mb10" style="margin-top: 25px"><img
                src="data:image/png;base64,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"
                alt="" class="f-mr20" style="width: 25px;"><img
                src="data:image/png;base64,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"
                alt="" style="width: 25px;"></div>
            <div class="notice f-mt10 f-tc" style="text-align: center;font-style: normal;margin-top: 4px;">
              关注官方账号及时获取更多精彩资讯</div>
          </div>
        </div>
      </template>
      <template v-if="lang == 'EN'">
        <div class="EN">
          <div class="centent">
            <p class="f-fs36 f-mt5 f-fwb" style="text-align: left;line-height: 35px;margin-top: 4px;">SWISSE PRODUCT
              AUTHENTICITY CHECK</p>
            <div class="f-fs18 f-mt20 f-ml5" style="text-align: left;margin-top: 21px;padding-left: 5px;">Please scratch
              to reveal the authenticity code</div>
            <div class="securityImg" style="margin-top: 21px;">
              <img src="@/assets/img/securityImg.3e5932e0.png" alt="">
            </div>
            <div class="f-mt28 f-fs18" style="text-align: left;margin-top: 25px;">Serial NO：{{ serial_number }}</div>
            <div>
              <input maxlength="20" type="text" placeholder="Input the authenticity code"
                style="margin-top: 7px;padding: 14.5px 5px;" class="securityInput" v-model="code">
            </div>
            <div><button class="securityBtn" style="padding: 15.5px 5px" @click="handleVerify">Verify</button></div>
            <div class="notice fsi">* Products without the authenticity code scratch panel are not supported to check
              via
              this app. Please contact the Swisse customer service team for any questions relating to the authenticity
              of
              your product.</div>
            <div class="notice f-mt10 fsi">
              * Swisse.com is the only legal domain name of the SWISSE PRODUCT AUTHENTICITY QUERY page. You can verify
              the
              genuine products to see swisse.com from the website address of this page, or by clicking the upper right
              [...] of this page if you use WeChat to scan. Please be aware of fraud.
            </div>
            <div class="f-mt28 f-tc f-mb10" style="margin-top: 26px"><img
                src="data:image/png;base64,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"
                alt="" class="f-mr20" style="width: 25px;"><img
                src="data:image/png;base64,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"
                alt="" style="width: 25px;"></div>
            <div class="notice  f-tc" style="text-align: center;font-style: normal;margin-top: 4px;">Follow the official
              account and
              get more wonderful information in time</div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="isResult">
      <!-- 防伪码不存在 -->
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 1 && lang == 'CN'">
        <h2 class="alertTitle">防伪码错误，谨防假冒</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/warming.918b0e34.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            您所输入的防伪码不正确，请检查是否有误。如果无误，则该产品为假冒产品。
          </div>
        </div>
      </div>
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 1 && lang == 'EN'">
        <h2 class="alertTitle">Warning</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/warming.918b0e34.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            We have detected an error with this code. Please be aware that this product may not be authentic
          </div><!---->
        </div>
      </div>

      <!-- 查询超过十次 -->
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 2 && lang == 'CN'">
        <h2 class="alertTitle">高频查询，谨防假冒</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/warming.918b0e34.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            该产品查询次数超过 <span style="color: #ce1e2b;">10</span> 次！如标签涂层未刮开，则产品为仿冒产品
          </div>
        </div>
      </div>
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 2 && lang == 'EN'">
        <h2 class="alertTitle">Caution</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/warming.918b0e34.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            This product label has been checked for authenticity over <span style="color: #ce1e2b;">10</span> times.
            Please be aware that this product may not be authentic. Please contact the Swisse customer service team for
            any questions relating to the authenticity of your product
          </div><!---->
        </div>
      </div>

      <!-- 查询低于十次 -->
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 0 && lang == 'CN'">
        <h2 class="alertTitle">查询产品为正品</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/gx.5232e717.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            该产品为第 <span style="color: #ce1e2b;">{{ num }}</span> 次查询，属正常查询
          </div>
        </div>
      </div>
      <div class="alertBox" style="padding: 12px 15px 0;text-align: left;box-sizing: border-box;"
        v-if="codeResult == 0 && lang == 'EN'">
        <h2 class="alertTitle">This product label is authentic</h2><!---->
        <div class="alertContent flexBox dbcenter01" style="display: flex;align-items: center;margin-top: 25px;">
          <img src="@/assets/img/gx.5232e717.png" alt="" class="flexBoxFixed">
          <div class="flexBoxAuto alertTxt" style="font-style: normal;box-sizing: border-box;">
            We have not detected any challenges with the authenticity of this product label. This is the <span
              style="color: #ce1e2b;">{{ num }}</span> authenticity check with this code.
          </div><!---->
        </div>
      </div>
      <div style="padding: 0 15px;"><button class="securityBtn" @click="handleBack">{{ lang == 'CN' ? '返回' : 'Back'
          }}</button></div>

    </template>
    <!-- <van-loading :color="color" :size="size" :text="text" :text-size="textSize" /> -->
    <van-popup v-model="popupShow" duration="0" closeable :close-on-click-overlay="false">
      <div class="popup-wrap">
        <img
          src="data:image/png;base64,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">
        <div class="p">是否允许‘Swisse斯维诗防伪查询’获取此设备的位置信息？以帮助我们更好的建立防伪体系</div>
        <div class="dialog_btn" style="margin-bottom:  8px;" @click="codeQuery">同意授权</div>
        <div class="dialog_btn" @click="codeQuery">拒绝</div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import { Loading } from 'vant';
export default {
  components: {
    VanLoading: Loading
  },
  data() {
    return {
      lang: 'CN',
      swithBoxShow: false,
      show: true,
      code: '',
      serial_number: '',
      isResult: false,
      codeResult: null,

      num: 0,


      // color: '#1989fa',
      // size: 30,
      // text: '加载中...',
      // textSize: 14,

      disabledVerify: false,
      popupShow: false,
    };
  },
  created() {
    this.getDetail()
  },
  methods: {
    handleBack() {
      this.isResult = false
      this.code = ''
      this.codeResult = null
    },
    getDetail(json) {
      this.$axios.post("/setting/setting").then((res) => {
        if (res.code == 200) {
          this.serial_number = res.data.serial_number || ''
        }
      });
    },
    handleVerify() {
      if (this.code == '' || this.code == null || this.code == undefined) {
        return this.$toast({
          size: 'large',
          message: this.lang == 'CN' ? '防伪码为空，请检查输入' : 'Authenticity code is required, please check the input.',
        });
      } else if (this.code.length <= 3) {
        return this.$toast({
          size: 'large',
          message: this.lang == 'CN' ? '防伪码有误，请检查输入' : 'Authenticity code error, please check the input',
        });
      }
      this.popupShow = true
    },
    codeQuery() {
      if (this.disabledVerify) return
      this.disabledVerify = true
      this.$axios.post("/anti/counterfeiting/code/query", { code: this.code }).then((res) => {
        this.popupShow = false
        this.disabledVerify = false
        if (res.code == 200) {
          this.codeResult = res.data.code
          this.isResult = true
          if (res.data.code == 0) {
            this.num = res.data.data.num || 0
          }
        }
      });
    },
    handleSwithBox(lang) {
      this.lang = lang
      this.swithBoxShow = false
    }
  }
};
</script>
<style>
.van-icon-cross {
  top: 8px;
  right: 10px;
  opacity: .6;
}


.van-toast {
  padding: 18px 20px;
  min-width: 70%;
  background-color: rgba(0, 0, 1, 0.9);

  div {
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
<style lang="less" scoped>
.popup-wrap {
  padding: 25px 10px 10px;

  img {
    width: 14px;
    margin-bottom: 15px;
  }

  .p {
    line-height: 22px;
    font-size: 18px;
    color: #333;
    text-align: left;
    margin-bottom: 15px;
  }

  .dialog_btn {
    min-width: 332px;
    border: .5px solid #848080;
    color: #000;
    display: block;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    font-weight: normal;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: none;

  }
}

body,
button,
input,
keygen,
legend,
select,
textarea {
  font: 12px/1.14 arial, \5b8b\4f53;
  outline: 0;
}

body {
  user-select: none;
}

.f-fs18 {
  font-size: 18px;
}

.f-mt30 {
  margin-top: 30px;
}

.f-mt28 {
  margin-top: 28px;
}

.f-mr20 {
  margin-right: 20px;
}

.wrap {
  text-align: center;
  color: #2c3e50;
  font-family: Avenir, Helvetica, Arial, sans-serif;

  .f-pr {
    position: relative;

    .swithLan {
      display: flex;
      align-items: center;
      position: absolute;
      right: 5px;
      top: 25%;
      color: #fff;
      line-height: 20px;
      font-size: 16px;

      img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }


    .swithBox {
      position: absolute;
      color: #fff;
      text-align: left;
      right: 5px;
      top: 100%;
      background: #000;
      border-radius: 3px;
      font-size: 14px;

      div {
        padding: 10px 12px;

        &.on {
          background-color: #333;
          border-radius: 3px;
        }
      }

    }

    img {
      border: 0;
      max-width: 100%;
      height: auto;
      vertical-align: middle;
      -ms-interpolation-mode: bicubic;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .securityImg {
    text-align: center;
    margin-top: 22px;

    img {
      width: 170px;
      height: 190px;
    }
  }

  .securityInput {
    border: 1px solid #000;
    padding: 15px 5px;
    width: 100%;
    margin-top: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 18px;
  }

  .grayBtn,
  .securityBtn {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 18px;
    padding: 15px 5px;
    margin-top: 10px;
  }

  .securityBtn {
    background: #ce1e2b;
    color: #fff;
  }

  b,
  button,
  em,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  input,
  select,
  strong,
  textarea {
    font-weight: 400;
    font-style: normal;
  }

  a,
  button {
    cursor: pointer;
    border: none;
  }

  .fsi {
    font-style: italic;
  }



  .notice {
    margin-top: 5px;
  }

  .alertTxt,
  .notice {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    text-align: left;
    color: #848080;
    font-size: 15px;
    font-style: italic;
    line-height: 17px;
  }

  .notice {
    margin-top: 5px;
  }

  .CN {

    .centent {
      padding: 0 15px;

      p {
        font-size: 18px;
        margin-top: 21px;
        padding-left: 5px;
        text-align: left;
      }

    }
  }

  .EN {

    .centent {
      padding: 0 15px;

      .f-fwb {
        font-weight: 700;
      }

      .f-fs36 {
        font-size: 30px;
      }

      .f-mt5 {
        margin-top: 5px;
      }
    }
  }

  .alertContent img {
    width: 52px;
    height: 52px;
  }

  .alertBox {
    height: 233px;
    text-align: left;
  }

  .flexBoxFixed {
    width: auto;
    display: block;
  }

  .alertContent {
    margin-top: 25px;
    overflow: hidden;
  }

  .dbcenter,
  .dbcenter01 {
    -webkit-box-align: center;
    display: -webkit-box;
  }

  .alertTxt {
    padding-left: 10px;
  }

  .alertTitle {
    font-size: 36px;
    color: #000;
    font-weight: 400;
    font-style: normal;
  }
}
</style>
